import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";
import React from "react";

export interface IDialogOption {
  title: string;
  handleOption: () => void;
  closeOnClick?: boolean;
}

interface IDialogComponentProps {
  title: string;
  onClose: () => void;
  isOpen: boolean;
  options: Array<IDialogOption>;
  children: React.ReactNode;
}

export const DialogComponent: React.FC<IDialogComponentProps> = ({
  title,
  onClose,
  isOpen,
  options,
  children,
}) => {
  const handleClose = () => {
    onClose();
  };

  const handleOptionAndClose = (option: IDialogOption) => {
    option.handleOption();
    if (option.closeOnClick ?? true) {
      handleClose();
    }
  };

  return (
    <div>
      <Dialog
        open={isOpen}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{title}</DialogTitle>

        <DialogContent>
          <DialogContentText component="div">
            <div id="alert-dialog-description">{children}</div>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          {options.map((option, index) => (
            <Button
              variant="outlined"
              key={index}
              onClick={() => handleOptionAndClose(option)}
            >
              {option.title}
            </Button>
          ))}
        </DialogActions>
      </Dialog>
    </div>
  );
};
